import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import Event from '../../modules/analytics/components/Event';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../modules/analytics/components/Event/Event.constants';
import { EventPropType } from '../../modules/analytics/types';
import Icon from '../../modules/foundation/components/Icon/Icon';
import { classNames } from '../../utils/classname';
var defaultProps = {
  className: '',
  iconName: '',
  ariaLabel: 'Call Business',
  event: {
    category: EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY,
    action: EVENT_ACTIONS.CONTACT_CALL_EVENT_ACTION
  }
};
export default function Phone(_ref) {
  var phone = _ref.phone,
    className = _ref.className,
    iconName = _ref.iconName,
    ariaLabel = _ref.ariaLabel,
    event = _ref.event;
  if (_isEmpty(phone)) {
    return null;
  }
  function getContent() {
    if (!_isEmpty(iconName)) {
      return /*#__PURE__*/React.createElement(Icon, {
        iconName: iconName
      });
    }
    return phone;
  }
  var finalClassName = classNames(_defineProperty({
    phone: true
  }, className, true));
  var phoneLink = /*#__PURE__*/React.createElement("a", {
    className: finalClassName,
    href: "tel:".concat(phone),
    "aria-label": ariaLabel
  }, getContent());
  if (!_isEmpty(event)) {
    phoneLink = /*#__PURE__*/React.createElement(Event, {
      eventType: "click",
      event: _has(event, 'label') ? event : _objectSpread(_objectSpread({}, event), {}, {
        label: phone
      })
    }, phoneLink);
  }
  return phoneLink;
}
Phone.defaultProps = defaultProps;